enum ActionStatus {
    Pending = 1,
    Complete = 2,
    Failed = 3,
}

export default ActionStatus;
